<div class="d-inline-flex">
  <ncp-button
    #addDeviceButton
    [options]="btnDIOptions()"
  >
    @if (!btnDIOptions().isLoading) {
      <img
        [ngSrc]="assets.healthIcons.svg.outline.devices.defibrillator.src"
        width="18"
        height="18"
        alt="Add Device/Implant"
        class="healthIcon"
      />
    }
  </ncp-button>

  <ncp-modal
    #mod
    [options]="modOptions()"
  >
    <form
      id="devices_form"
      name="devices_form"
      [formGroup]="form"
      #diFrm="ngForm"
      class="d-flex flex-column gap-3"
      (ngSubmit)="onFormSubmit()"
    >
      <ncp-dropdown #deviceDesc [(options)]="deviceDescDDOptions" />
      <ncp-date #deviceDate [(options)]="implantDateOptions" />
    </form>
  </ncp-modal>
</div>
